import { PJAxios, PJLinkSalto, usePJStore } from '@jaf/jaf-react-core';
import React, { useEffect, useRef, useState } from 'react';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { useLocation } from 'react-router-dom';
import { flushCache } from '../../../api/ChatbotApi';

function ProprietaForm(props) {

    const [loading, setLoading] = useState(false);
    const [formTypeSelectItems, setFormTypeSelectItems] = useState(null);
    const [formType, setFormType] = useState(null);
    const [visibilityFilter, setVisibilityFilter] = useState("");
    const { useHistory } = usePJStore(state => state.router)

    const [idGruppoSelezionato, setIdGruppoSelezionato] = useState(props.idGruppoSelezionato);

    const [modifiedNodes, setModifiedNodes] = useState([]);

    const toast = useRef(null);

    const getText = usePJStore((state) => state.i18n_getText)
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)


    const [gruppoSelezionatoDs, setGruppoSelezionatoDs] = useState(null);
    const [gruppoSelezionatoDn, setGruppoSelezionatoDn] = useState(null);

    const [groups, setGroups] = useState(null);
    const [dettaglioGruppi, setDettaglioGruppi] = useState(false)

    // Aggiungi questi stati nel componente
    const [filterList, setFilterList] = useState([]);
    const [newId, setNewId] = useState('');

    const history = useHistory();

    useEffect(() => {
        fillSession()
    }, []);

    // Effetto per sincronizzare la lista quando cambia la stringa originale (es. al caricamento)
    useEffect(() => {
        setFilterList(parseFilterToArray(visibilityFilter));
    }, [visibilityFilter]);

    const addId = () => {
        if (newId) {
            const currentIds = parseFilterToArray(visibilityFilter).map(item => item.id);
            if (!currentIds.includes(newId.toString())) {
                const newList = [...currentIds, newId.toString()];
                const newFilterString = `[G:${newList.join(',')}]`;
                setVisibilityFilter(newFilterString);

                // Opzionale: se l'ID è nuovo, potresti voler rifare la chiamata 
                // al server per recuperare i dettagli anche di questo nuovo ID
                PJAxios().post('/gestioneConfigurazioni/getGroupsInfo', newFilterString).then((res) => {
                    setGroups(res.data);
                });
            }
            setNewId('');
        }
    };

    const removeId = (idToRemove) => {
        const currentIds = parseFilterToArray(visibilityFilter).map(item => item.id);
        const newList = currentIds.filter(id => id.toString() !== idToRemove.toString());
        const newFilterString = newList.length > 0 ? `[G:${newList.join(',')}]` : "";
        setVisibilityFilter(newFilterString);
    };

    // Funzione per incrociare gli ID nel filtro con i dati completi dei gruppi
    const getDetailedFilterList = () => {
        const activeIds = parseFilterToArray(visibilityFilter).map(item => item.id);

        if (!groups) return activeIds.map(id => ({ id_group: id, nome_gruppo: "Caricamento..." }));

        return activeIds.map(id => {
            // Cerchiamo il gruppo corrispondente nei dati arrivati dal server
            const groupInfo = groups.find(g => g.id_group.toString() === id.toString());
            return groupInfo ? groupInfo : { id_group: id, nome_gruppo: "ID non trovato" };
        });
    };

    useEffect(() => {
        //console.log(props.selectedNode)
        if (props.selectedNode.filter != null && props.selectedNode.filter.length > 0) {
            PJAxios().post('/gestioneConfigurazioni/getGroupsInfo', props.selectedNode.filter).then((res) => {
                console.log("getGroupsInfo", res.data)
                setGroups(res.data)
            });


        }

    }, [props.selectedNode]);



    const fillSession = () => {

        sessionStorage.setItem("selectedNode", JSON.stringify(props.selectedNode))
        sessionStorage.setItem("tematica", JSON.stringify(props.tematica))
        sessionStorage.setItem("selectedNodeKey", props.selectedNodeKey);
    }

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let query = useQuery();

    const finalFiltroVis = (idGruppo) => {

        let oldFiltro = props.selectedNode.filter != null ? props.selectedNode.filter : "";
        if (oldFiltro.length == 0 && idGruppo != null) {
            setVisibilityFilter("[G:" + idGruppo + "]");
        } else if (idGruppo != null) {

            if (!oldFiltro.includes(idGruppo)) {
                oldFiltro = oldFiltro.replace("[G:", "")
                oldFiltro = oldFiltro.replace("]", "")
                oldFiltro = oldFiltro + "," + idGruppo
                setVisibilityFilter("[G:" + oldFiltro + "]")
            } else {
                setVisibilityFilter(oldFiltro)
            }
        } else if (oldFiltro.length > 0) {
            setVisibilityFilter(oldFiltro)
        } else {
            setVisibilityFilter("")
        }
    }

    useEffect(() => {

        let sessionSelectedNode = JSON.parse(sessionStorage.getItem("selectedNode"))

        if (sessionSelectedNode != null && sessionSelectedNode.elemento_id === props.selectedNode.elemento_id) {
            setIdGruppoSelezionato(props.id_gruppo_selezionato)
            finalFiltroVis(props.id_gruppo_selezionato)
            props.onJumpBack()
        } else {
            setIdGruppoSelezionato(null)
            finalFiltroVis(null)
        }

        PJAxios().get('/gestioneConfigurazioni/loadFormTypes/' + props.selectedNode.formTag).then((res) => {
            setFormTypeSelectItems(getDropdownItems(res.data))
        });

        //setFormTypeSelectItems(getDropdownItems(props.selectedNode.elemento.extra_fields.tipo_form));

    }, [props.selectedNode]);

    const updateFormProperties = () => {
        var item = { is_new: false, id_item: props.selectedNode.idItem, id_element: "tipo_form", op_type: "mod_el", obj_type: "menu", new_val: formType.valore + "," }
        modifiedNodes.push(item);
        item = { is_new: false, id_item: props.selectedNode.idItem, id_element: "filtro_vis", op_type: "mod_el", obj_type: "menu", new_val: visibilityFilter }
        modifiedNodes.push(item);
        setModifiedNodes(modifiedNodes)
        salvaTutto();
    }

    const salvaTutto = () => {

        fillSession()

        setLoading(true);

        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
            props.onSave(props.tematica, true);
            setModifiedNodes([]);
            setLoading(false);
            flushCache(dbTest);
            history.push("/")
        });
    }

    const getDropdownItems = (forms) => {
        let items = [];

        setFormType(forms[0]);

        forms.forEach((form, index) => {
            let item = { label: form.descrizione, value: form, selected: form.selected };
            items.push(item);
            if (form.selected === true) {
                setFormType(form);
            }
        })
        return items;
    }

    const gruppoRespTemplate = (row) => {
        if (row.id_gruppo_resp > 0) {
            return row.id_gruppo_resp + " - " + row.nome_gruppo_resp
        } else {
            return "-"
        }
    }

    // Funzione helper per estrarre i numeri dalla stringa [G:123,456]
    const parseFilterToArray = (filterString) => {
        if (!filterString || !filterString.includes("[G:")) return [];
        const match = filterString.match(/\[G:(.*)\]/);
        if (match && match[1]) {
            return match[1].split(',').filter(id => id !== "").map(id => ({ id: id.trim() }));
        }
        return [];
    };

    // Funzione helper per ricostruire la stringa [G:123,456]
    const formatArrayToFilter = (array) => {
        if (array.length === 0) return "";
        const ids = array.map(item => item.id).join(',');
        return `[G:${ids}]`;
    };

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading &&
                <>
                    <div className="formgrid grid">
                        <div className="col-12">
                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("PROPRIETA_FORM")}</b></h6></span>

                            <div className="formgroup-inline col-12 md:col-12">
                                <div className="col-3 md:col-3">{getText("TIPO_FORM")}</div>
                                <div className="col-9 md:col-9">
                                    <span className="p-fluid">
                                        <Dropdown value={formType} options={formTypeSelectItems} onChange={(e) => setFormType(e.value)} placeholder="" />
                                    </span>
                                </div>
                            </div>
                            <div>&nbsp;</div>
                            <div className="formgroup-inline col-12 md:col-12">
                                <div className="col-3 md:col-3">{getText("FILTRO_VISIBILITA")}</div>
                                <div className="col-9 md:col-9">
                                    {/* Sezione Input per nuovo ID */}
                                    <div className="col-12 md:col-12">
                                        <div className="flex gap-2 mb-3">
                                            <div className="p-inputgroup flex-1">
                                                <input
                                                    type="number"
                                                    className="p-inputtext p-component"
                                                    value={newId}
                                                    onChange={(e) => setNewId(e.target.value)}
                                                    placeholder="Inserisci ID Gruppo"
                                                />
                                                <Button icon="pi pi-plus" onClick={addId} disabled={!newId} />
                                            </div>
                                        </div>

                                        <DataTable
                                            value={getDetailedFilterList()}
                                            size="small"
                                            scrollable
                                            scrollHeight="250px"
                                            emptyMessage="Nessun gruppo configurato nel filtro"
                                            responsiveLayout="stack"
                                        >
                                            <Column field="id_group" header="ID" style={{ width: '15%' }} />
                                            <Column field="nome_gruppo" header="Nome Gruppo" style={{ width: '35%' }} />
                                            <Column field="descrizione" header="Descrizione" style={{ width: '40%' }} />
                                            <Column
                                                body={(rowData) => (
                                                    <Button
                                                        type="button"
                                                        icon="pi pi-trash"
                                                        className="p-button-danger p-button-text"
                                                        onClick={() => removeId(rowData.id_group)}
                                                    />
                                                )}
                                                style={{ width: '10%' }}
                                            />
                                        </DataTable>
                                    </div>
                                </div>
                                {false &&
                                    <div className="col-6 md:col-3">
                                        <div>
                                            {groups != null && groups.length > 0 &&
                                                <Button icon="pi pi-list" label={getText("DETTAGLIO_GRUPPI")} onClick={() => setDettaglioGruppi(true)} />
                                            }

                                        </div>
                                        <div style={{ paddingTop: "1em" }}>
                                            <PJLinkSalto id_servizio="1044" label={getText("LBL_CERCA_GRUPPO")} icon="pi pi-search" type="button" returnParams={{ gruppo_selezionato_ds: gruppoSelezionatoDs, gruppo_selezionato_dn: gruppoSelezionatoDn, id_gruppo_selezionato: idGruppoSelezionato }}></PJLinkSalto>
                                        </div>


                                    </div>
                                }
                            </div>
                            <div className="formgroup-inline col-12 md:col-12">
                                <Button onClick={updateFormProperties} icon="pi pi-save" label={getText("SALVA")}></Button>
                            </div>

                            <Dialog header={getText("DETTAGLIO_GRUPPI")} visible={dettaglioGruppi} onHide={() => setDettaglioGruppi(false)}>
                                <DataTable value={groups}>
                                    <Column field='id_group' header={getText("ID")} />
                                    <Column field='nome_gruppo' header={getText("LBL_NOME")} />
                                    <Column field='descrizione' header={getText("DESCRIZIONE")} />
                                    <Column field='query_gruppo' header={getText("QUERY")} />
                                    <Column body={gruppoRespTemplate} header={getText("GRUPPO_RESP")} />
                                </DataTable>
                            </Dialog>
                        </div>
                    </div>
                    <div className="p-fluid grid formgrid col-6">
                        <Toast ref={toast}></Toast>
                    </div>
                </>
            }
        </>
    )
}

export default ProprietaForm
